export default __webpack_public_path__ + "static/houses_1-ec4234c4756a9c7227070efda8521634.png";